/** Página de fallback para qualquer caminho que não corresponde a nenhuma rota registrada. */
export function criarPaginaNaoEncontrada(): HTMLElement {
  const container = document.createElement('div');
  container.innerHTML = `
    <pg-card>
      <pg-empty-state
        variant="vazio"
        titulo="Página não encontrada"
        descricao="O caminho acessado não existe."
      ></pg-empty-state>
    </pg-card>
  `;
  return container;
}
